export enum TagType {
  regular = 'regular',
  temp = 'temp',
  warning = 'warning'
}
